// src/components/PageLoader/PageLoader.tsx
import styles from './PageLoader.module.scss';

interface PageLoaderProps {
	/** Optional message shown under the mark. Defaults to a subtle label. */
	label?: string;
}

/**
 * Full-viewport branded loader used as the Suspense fallback during
 * lazy route transitions. Centered mark with a lime progress sweep.
 */
const PageLoader = ({ label = 'Loading' }: PageLoaderProps) => {
	return (
		<div
			className={styles.overlay}
			role='status'
			aria-live='polite'>
			<div className={styles.inner}>
				<div
					className={styles.mark}
					aria-hidden='true'>
					<span className={styles.dot} />
					<span className={styles.dot} />
					<span className={styles.dot} />
				</div>
				<div
					className={styles.track}
					aria-hidden='true'>
					<span className={styles.sweep} />
				</div>
				<span className={styles.label}>{label}</span>
			</div>
		</div>
	);
};

export default PageLoader;
